import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_veedhainvestimentos.png",
      alt: "Estratégias VeedhaBot",
    },
    title: "VeedhaBot",

    // String ou array de strings
    text: "Estratégia de day-trade, baseada em níveis de volatilidade. O design desse algoritmo favorece entradas em regiões com maior probabilidade de lucro, sendo totalmente adaptável aos ciclos do mercado. Possui uma relação risco x retorno positiva, utilizando Stop Loss e Take Profit dinâmicos, porém com perda máxima controlada, além de contar com um trailling stop para garantir o lucro da operação, quando acionado. Lembrando que, por se tratar de um algoritmo dinâmico e adaptável, os parâmetros podem sofrer alterações conforme as estratégias são recalibradas.",
    testimonial: {
      text: "Nas voláteis ondas do mercado, a adaptação estratégica é a chave para alcançar ganhos além da média, sem negligenciar a segurança e o controle de risco.",
      author: {
        name: "Rodrigo Moliterno, Head de Renda Variável Veedha Investimentos",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégia VeedhaBot",
    heading:
      "Estratégia adaptável aos ciclos do mercado com maior probabilidade de lucro",
    subtitle:
      "O algoritmo Veedha WIN atua com mini-índice e o Veedha WDO com mini-dólar futuro, usando análises quantitativas para ganhos acima da média, com segurança e controle de risco. Recomendamos usar ambas as estratégias para melhores resultados no longo prazo.",
  },

  cta: {
    title: "Tudo pronto?",
    subtitle: "Ative agora mesmo a extensão VeedhaBot",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Veedha",
    col1: [
      "A Veedha é uma empresa especializada em operações de day-trade, baseadas em níveis de volatilidade. Seu algoritmo estratégico favorece entradas lucrativas e é totalmente adaptável aos ciclos do mercado.",
      "Com análises quantitativas, o algoritmo Veedha WIN para mini-índice futuro e Veedha WDO para mini-dólar futuro buscam obter ganhos acima da média, mantendo o controle de risco e segurança operacional. A empresa recomenda o uso simultâneo das estratégias para maximizar lucros e diminuir perdas no longo prazo.",
    ],
    col2: [
      "Transparência, compromisso e adaptabilidade são os pilares da Veedha Investimentos, que oferece aos investidores uma abordagem dinâmica e promissora no mercado financeiro.",
    ],
  },

  stats: {
    title: "Alguns números da Veedha",
    subtitle:
      "Décadas de expertise com números que provam o nosso conhecimento de mercado.",
    data: [
      {
        value: "+8 bi",
        description: "Sob custódia",
      },
      {
        value: "+15k",
        description: "Clientes",
      },
      {
        value: "Top 10",
        description: "Escritórios da XP",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Veedha?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Criado e monitorado pelos assessores traders da Veedha",
        description:
          "Décadas de expertise criaram o melhor robô de day trade do mercado",
      },
      {
        icon: iconsSet.chat_round,
        title: "Acesso ao suporte exclusivo da Veedha",
        description:
          "Converse diretamente com os traders da Veedha para tirar suas dúvidas",
      },
      {
        icon: iconsSet.preference,
        title: "Variedade",
        description:
          "Opere minicontratos de Dólar e Índice com as estratégias da Veedha",
      },
      {
        icon: iconsSet.analytics,
        title: "Estratégia com histórico",
        description:
          "A Veedha já opera diariamente mais de 10 mil minicontratos, o que mostra que o nosso algoritmo já é baseado em um alto volume de negociação",
      },
      {
        icon: iconsSet.ads_click,
        title: "Simples de usar",
        description:
          "Ativando a extensão basta um toque para ativar a sua estratégia",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
